import {useEffect, useState} from 'react';
import {getImageUrl, revokeImageUrl} from '../utils/imageUtils';

/**
 * Hook for loading authenticated images
 * @param {string} imagePath - The image path from the backend
 * @param {string} imageUrl - The direct image URL (for S3)
 * @returns {Object} - Object containing imageUrl, loading state, and error state
 */
export const useAuthenticatedImage = (imagePath, imageUrl = null) => {
    const [imageUrlState, setImageUrlState] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);


    useEffect(() => {
        let mounted = true;

        const loadImage = async () => {
            // Validate inputs - if both are empty/null/undefined, don't proceed
            if (!imageUrl && !imagePath) {
                setImageUrlState(null);
                setLoading(false);
                setError(null);
                return;
            }

            // If we have a direct imageUrl, use it immediately
            if (imageUrl && imageUrl.trim() !== '') {
                setImageUrlState(imageUrl);
                setLoading(false);
                setError(null);
                return;
            }

            // If we have a valid imagePath, try to load it
            if (imagePath && imagePath.trim() !== '') {
                // Valid imagePath, proceed with loading
            } else {
                setImageUrlState(null);
                setLoading(false);
                setError(null);
                return;
            }

            setLoading(true);
            setError(null);

            try {
                console.log('Fetching authenticated image for path:', imagePath);
                const url = await getImageUrl(imagePath, null);
                console.log('Got authenticated URL:', url);
                if (mounted) {
                    setImageUrlState(url);
                }
            } catch (err) {
                if (mounted) {
                    setError(err);
                    setImageUrlState(null);
                }
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        };

        loadImage();

        // Cleanup function
        return () => {
            mounted = false;
        };
    }, [imagePath, imageUrl]);

    // Cleanup blob URLs when component unmounts or URL changes
    useEffect(() => {
        return () => {
            if (imageUrlState && imageUrlState.startsWith('blob:')) {
                revokeImageUrl(imageUrlState);
            }
        };
    }, [imageUrlState]);

    return {imageUrl: imageUrlState, loading, error};
};
